<script lang="ts">
	import { Code } from "@connectrpc/connect";
	import { Img } from "flowbite-svelte";
	import { twMerge, type ClassNameValue } from "tailwind-merge";
	import { Mode } from "#gen/bundles/v1/service_pb.js";
	import { APIError } from "#lib/api/error.js";
	import P from "#lib/components/P.svelte";

	interface Props {
		error: unknown;
		mode?: Mode;
		class?: ClassNameValue;
	}

	const { error, mode = Mode.LIVE, class: className }: Props = $props();
</script>

<div class={twMerge("flex h-full w-full flex-col items-center", className)}>
	<div class="flex max-w-80 grow flex-col justify-center">
		<Img class="-mt-24 mb-8 inline-block" src="/page-not-found.avif" alt="Something went wrong" />
		<P class="text-sm" align="center">
			{#if error instanceof APIError && error?.code === Code.InvalidArgument}
				{#if mode === Mode.LIVE}
					This page appears to be unfinished. Check back later!
				{:else}
					This page appears to be unfinished. Your Suite or Entrypoint Code may be missing some data.
				{/if}
			{:else if mode === Mode.LIVE}
				Something went wrong rendering this page. The author may fix it, so check back later.
			{:else}
				Something went wrong rendering your page and our team has been notified. Contact support@flowcode.com with any questions!
			{/if}
		</P>
	</div>
</div>
